/* RESPONSIBLE TEAM: team-self-serve */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend({
  collectionKey: 'prices',
});
